export const LOADING_STATE_SLICE = 'LOADING_STATE_SLICE';
